<template>
  <div class="Details">
  <section>
    

    <div class="columns">
      

          <div class="column">
        <div class="box">
              
                <h4 class="title is-5">Playground
                  &nbsp;&nbsp;<b-tag type="is-success">hosted</b-tag>&nbsp;
                  <b-tag type="is-success is-light">production-ready endpoint</b-tag>

                </h4>
              
              <div class="block">
                {{ model.how_to_use}}
              </div> 
              <form v-on:submit.prevent="invoke()" >
              <b-field><!-- :label="(model.type)">-->
                  <b-input maxlength="100" 
                  required
                  type="textarea" v-model="model.prompt.input" 
                  placeholder="Type your text here">
                  </b-input>
              </b-field>
              
              <b-button
              tag="button"
              native-type="submit"
              value="Compute"
              >Compute</b-button>
              
              </form>
          
          <b-notification :closable="false" v-if="isLoading">
              Invoking the model. It can take some seconds.
              <b-loading :is-full-page="false" v-model="isLoading" :can-cancel="false">
              </b-loading>
            </b-notification>
            
          <div class="columns" v-if="result && !isLoading">
              
              <div class="column">
                <br>
                
                  <!-- <b-tag size="is-medium">Prediction: </b-tag> -->
                  <b-message>
                  <p>
                    {{ result }}
                  </p>
                  </b-message>
                
              </div>
          </div>
          </div>
          </div>
    </div>
      
      
  </section>

  </div>
</template>
<script>
import firebase from 'firebase/compat/app';
 export default {
   props: ["model","modelId", "currentUser"],
   name: "API",
   data: function() {
  return {
      model_url: 'https://api.metatext.ai/inference/' + this.modelId,
      model_url_batch: 'https://api.metatext.ai/inference-batch/' + this.modelId,
      model_hub_url: 'https://api.metatext.ai/hub-inference/' + this.modelId,
      model_hub_base_url: 'hub-inference',
      model_base_url: 'inference',
      api_key: 'YOUR_API_KEY',
      all_users_api_key: 'Z0CDIgI42M5hggX0bpBB61UZswN4NiHNaqqsFIWd',
      text: "",
      result: '',
      isLoading: false,
      code_examples: [
          {name: "cURL", code: "code", is_active:1},
          {name: "Python", code: "code"},
          {name: "NodeJS", code: "code"},
          /*{name: "GO", code: "code"},
          {name: "Rust", code: "code"},
          {name: "Java", code: "code"},
          {name: "Ruby", code: "code"},
          {name: "R", code: "code"},
          {name: "Julia", code: "code"},*/
      ]
    }},
   computed: {
     items() {
       return this.$store.state.currentModelItems;
     }
   },
   methods: {
       getApiKey(){
          if(this.currentUser.apiKey != undefined){
            return this.currentUser.apiKey
          } else {
            return this.all_users_api_key
          }
       },
       getInferenceUrl() {
        if (this.model.hub_only == true){
          return this.model_hub_url
        } else {
          return this.model_url
        }
       },
       getBaseInferenceUrl() {
        if (this.model.hub_only == true){
          return this.model_hub_base_url
        } else {
          return this.model_base_url
        }
       },
       copyURL(data) {
          
          data.select();
          document.execCommand("copy");
      },
      async invoke() {
        this.isLoading = true
        // this.$buefy.notification.open(`Calling model API`)
        //this.$buefy.notification.open('Request time: '+parseFloat(response_time).toFixed(3)+' s.')
        const payload = {
          userId: firebase.auth().currentUser.uid, 
          modelId: this.model.id, 
          text: this.model.prompt.input,
          hub: (this.model.hub_only == true),
          hub_prompt_template: this.model.gpt_prompt,
          model_base_url: this.getBaseInferenceUrl()
        }
        
        const result = await this.$store.dispatch("getModelInference", payload);
        
        const toUpdate = {
              userId: firebase.auth().currentUser.uid, 
              update: {
                  predictionsTotal: (this.currentUser.predictionsTotal == undefined ? 0 : this.currentUser.predictionsTotal)
              }
        }

        this.$store.dispatch("updateModelPredictionsTotal", 
          toUpdate
        )

        this.result = result
        this.isLoading = false
      }
   },
   created() {
     // console.log(this.pageId)
     //this.$store.dispatch("displayModelDetails", this.boardId);
     this.training = true
     this.options = {},
     this.currentTab = "details"
     // this.model_url = 'https://api.metatext.io/v1/model/' + this.model.id
     // this.series = [44, 55, 41, 17, 15]
   }
 };
</script>